type MetricItem = {
  label: string;
  value: string | number;
  icon: string;
  tone: string;
  helper?: string;
};

const MetricCard = ({ metric }: { metric: MetricItem }) => (
  <article className={`metric metric-${metric.tone}`}>
    <div className="metric-top">
      <span className="metric-icon">{metric.icon}</span>
      <div className="metric-label">
        <p>{metric.label}</p>
        <strong>{metric.value}</strong>
      </div>
    </div>
    {metric.helper ? <small>{metric.helper}</small> : null}
  </article>
);

export default MetricCard;
